import { Text as ChakraText } from '@chakra-ui/react';

export default function Text(props) {
  return <ChakraText {...props} />;
}
